module.exports = __webpack_public_path__ + "static/media/20180524-LCS-014-13.3216a3dd.jpg";